
import { useState, useEffect } from 'react';
import axios from 'axios';

const useIATrainingData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://niaserver-05287f289508.herokuapp.com/iaTraining/getAll');
        console.log('API Response:', response); 
        console.log('API Response Data:', response.data); 


        if (Array.isArray(response.data) && response.data.length > 0) {
          const dataRows = response.data[0]; 
          setData(dataRows); 
        }

        setLoading(false); 
      } catch (err) {
        console.error('Error fetching data:', err.response || err);
        setError(err); 
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};

export default useIATrainingData;
